import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IntegrationFragment } from './fragments'
import { IIntegration, IUpdateInput, IUpdatePayload } from './types'
import handleFetchResult from '@utils/handleFetchResult'

const mutateHandler = handleFetchResult<IUpdatePayload, IIntegration>({
  handler: (data) => data.updateIntegration.integration,
  name: 'Integration',
})

export default function update(input: IUpdateInput): Promise<IIntegration> {
  return client.gql.mutate({ mutation, variables: { input } }).then(mutateHandler)
}

const mutation = gql`
  mutation Update($input: UpdateIntegrationInput!) {
    updateIntegration(input: $input) {
      integration {
        ...IntegrationFragment
      }
    }
  }
  ${IntegrationFragment}
`
